import { apiService } from "../apiServices";
import config from "../../../config/domain";
import servicesList from "../serviceList";

/**
 * Dion Post Data API
 */
export const ADionPostData = (callback: CallableFunction, dionObj: any) => {
  apiService(
    {
      url: "Dion/PostData",
      body: {
        accountCategory: dionObj?.accountCategory,
        applicationId: dionObj?.applicationId,
        stage: dionObj?.stage,
        userId: dionObj?.userId,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
      encrypted: true,
    },
    callback
  );
};

/**
 * E-Log Registration API
 */
export const AElogRegistration = (callback: CallableFunction, elogObj: any) => {
  apiService(
    {
      url: "Elog/Registration",
      body: {
        clientCode: elogObj?.ClientCode,
        FirstHolderIpAdd: elogObj?.FirstHolderIpAdd,
        SecondHolderIpAdd: elogObj?.SecondHolderIpAdd,
        ThirdHolderIpAdd: elogObj?.ThirdHolderIpAdd,
        EntitySubType: elogObj?.EntitySubType,
      },
      method: "POST",
      apiBaseUrl: config.diyNewApiUrl,
      tempToken: config.tempToken,
      serviceName: servicesList.getStageCompletionStatus,
      encrypted: true,
    },
    callback
  );
};
